<template>
  <div :class="[dialogShow ? 'page_body dialog_show' : 'page_body']">
    <div class="login_body">
      <img
        class="login_body_bg"
        src="https://sh-basketball.oss-cn-shanghai.aliyuncs.com/index/basketball_index.jpg"
      />
      <!-- <div class="login_img_box">
        <img class="login_img" src="../../assets/image/login_img01.png" />
        <div class="login_img_name">上海市青少年篮球技能</div>
        <div class="login_img_name">等级考试报名</div>
      </div> -->
      <!-- 微信H5环境提示 -->
      <div class="wechat_h5_tip_box" v-if="isWeixinH5">
        <div class="wechat_h5_tip_content">
          <div class="wechat_h5_tip_title">提示</div>
          <div class="wechat_h5_tip_text">
            请在微信中打开"上海市篮球协会数据服务中心"小程序进行登录
          </div>
          <div class="wechat_h5_tip_text_small">
            微信H5环境暂不支持登录，请使用小程序
          </div>
        </div>
      </div>
      <div class="login_btn_box" v-else>
        <!-- <div
          class="login_btn"
          style="margin-bottom: 0.4rem"
          @click="wxLoginFn()"
        > -->
          <!-- <div class="login_btn" style="margin-bottom: 0.6rem" @click="testFn()">
          登录/login -->
          <div class="login_btn" style="margin-bottom: 0.6rem" @click="wxLoginFn()">
            登录/login
        </div>
      </div>
      <!-- 提示框 -->
      <div class="dialog_block" v-if="dialogShow">
        <div class="dialog_block_box">
          <img
            class="dialog_block_close"
            src="../../assets/image/close_icon01.png"
            @click="closeDialog()"
          />
          <div class="login_dialog_content">
            <div class="login_dialog_content_title">提示</div>
            <div class="login_dialog_content_title">您还没有完善信息</div>
            <div class="login_dialog_content_tips">
              <img
                class="login_dialog_content_tips_icon"
                src="../../assets/image/warning_icon01.png"
                alt=""
              />
              <div class="login_dialog_content_tips_words">
                完善信息后才能浏览其他内容
              </div>
            </div>
            <div class="login_dialog_content_btn" @click="toRegister()">
              去完善
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="../../assets/css/home/login.css" scoped></style>

<script>
import { Toast } from "mint-ui";
// 引入微信JSSDK
import wx from "weixin-js-sdk";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      dialogShow: false, // 弹框显示
      realUrl: "",
      wxJSSDKConfig: {}, // 微信JSSDK配置
      isWeixinH5: false, // 是否为微信H5环境
    };
  },
  created: function () {
    let that = this;
    let query = this.$route.query;
    
    // 检测是否为微信H5环境
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    // 检测是否在小程序环境（通过userAgent判断）
    let isMiniProgram = /miniProgram/i.test(ua) || window.__wxjs_environment === 'miniprogram';
    // 如果是微信环境但不是小程序，则是微信H5环境
    this.isWeixinH5 = isWeixin && !isMiniProgram;
    
    // 检查是否有小程序传递的token
    if (query.minitoken) {
      // 直接使用小程序token自动登录
      this.$store.commit("set_loginToken", query.minitoken);
      // 清除URL参数
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
      // 获取用户信息（userid和is_register）
      this.getUserInfoByToken();
      // 跳转到首页
      this.$router.replace({ name: "Home" });
      return;
    }
    
    // 如果是微信H5环境，不执行后续登录逻辑
    if (this.isWeixinH5) {
      return;
    }
    
    if (query.code) {
      this.sendlCodeFn(query.code);
    }
    // 如果是微信H5环境，不获取JSSDK配置
    if (this.isWeixinH5) {
      return;
    }
    
    this.realUrl = this.$store.state.baseUrl + this.$route.fullPath;
    this.getWXJSSDKConfigFn().then((r) => {
      if (r) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: that.wxJSSDKConfig.appid, // 必填，公众号的唯一标识
          timestamp: that.wxJSSDKConfig.time, // 必填，生成签名的时间戳
          nonceStr: that.wxJSSDKConfig.password, // 必填，生成签名的随机串
          signature: that.wxJSSDKConfig.signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData"], // 必填，需要使用的 JS 接口列表
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: "上海市篮球协会青少年篮球技能等级考试报名", // 分享标题
            desc: "", // 分享描述
            link: that.$store.state.baseUrl + "/login", // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl:
              that.$store.state.baseAPIUrl + "/image/common/index_logo.png", // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });

        wx.error(function (res) {
          if (
            res.errMsg == "config:invalid signature" &&
            res.realAuthUrl[0] != "" &&
            res.realAuthUrl[0] != undefined
          ) {
            that.realUrl = res.realAuthUrl[0];
          }
          // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
        });
      }
    });
  },
  methods: {
    // 前往完善信息
    toRegister: function () {
      this.$router.push({
        name: "Register",
        params: {
          editKey: 1,
        },
      });
    },
    // 显示弹窗
    openDialog: function () {
      this.dialogShow = true;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.dialogShow = false;
      this.$router.replace({
        name: "Home",
      });
    },
    // 微信授权登录
    wxLoginFn: function () {
      let appid = "wx9271f3e414dea712";
      let redirect_uri = "https://shslqxh.1meeting.com/login";
      let response_type = "code";
      let scope = "snsapi_userinfo";
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        redirect_uri +
        "&response_type=" +
        response_type +
        "&scope=" +
        scope +
        "&state=STATE#wechat_redirect";
    },
    // 发送code到后端换取用户信息及token
    sendlCodeFn: function (code) {
      let that = this;
      let url = "/mobile/login";
      let data = {
        code: code,
      };
      this.axios
        .post(url, data)
        .then((response) => {
          if (response.code == 0) {
            that.$store.commit("set_loginToken", response.token);
            that.$store.commit("set_loginUserId", response.userid);
            that.$store.commit("set_isRegister", response.is_register);
            if (response.is_register == 1) {
              that.dialogShow = true;
            } else {
              that.$router.replace({
                name: "Home",
              });
            }
          } else {
            Toast({
              message: response.msg,
              duration: 3000,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 获取WXJSSDK配置
    getWXJSSDKConfigFn: function () {
      let that = this;
      let data = {};
      data = {
        url: this.realUrl,
      };
      let url = "/mobile/getjssdkconfig";
      return new Promise(function (resolve, reject) {
        that.axios
          .post(url, data)
          .then((response) => {
            if (response.code == 0) {
              that.wxJSSDKConfig = response.signpackage;
              resolve(true);
            } else {
              Toast({
                message: response.msg,
                duration: 3000,
              });
              resolve(false);
            }
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    // 根据token获取用户信息
    getUserInfoByToken: function () {
      let that = this;
      // 调用获取用户信息的接口，获取userid和is_register
      this.axios.post('/mobile/personalinfo', {})
        .then((response) => {
          if (response.code == 0) {
            // 如果接口返回了userid，设置到store
            if (response.userid) {
              that.$store.commit('set_loginUserId', response.userid);
            } else if (response.userinfo && response.userinfo.id) {
              // 如果userinfo中有id，也可以使用
              that.$store.commit('set_loginUserId', response.userinfo.id);
            }
            
            // 判断是否完善信息
            if (response.is_register !== undefined) {
              // 如果接口返回了is_register，直接使用
              that.$store.commit('set_isRegister', response.is_register);
            } else if (response.userinfo) {
              // 如果接口没有返回is_register，根据userinfo判断
              // 如果userinfo有name和identity_number，说明已完善信息
              if (response.userinfo.name && response.userinfo.identity_number) {
                // 已完善信息，设置为0（表示已完善）
                that.$store.commit('set_isRegister', 0);
                console.log('根据userinfo判断：已完善信息');
              } else {
                // 未完善信息，设置为1（表示未完善）
                that.$store.commit('set_isRegister', 1);
                console.log('根据userinfo判断：未完善信息');
              }
            }
            console.log('用户信息获取成功', response);
          } else {
            console.error('获取用户信息失败:', response.msg);
            // 如果接口返回-4，说明需要完善信息
            if (response.code == -4) {
              that.$store.commit('set_isRegister', 1);
            }
          }
        })
        .catch(function (error) {
          console.error('获取用户信息异常:', error);
        });
    },
    testFn: function () {
      let that = this;
      let url = "/mobile/login";
      let data = {
        code: "",
        login_userid: "75565",
      };
      this.axios
        .post(url, data)
        .then((response) => {
          if (response.code == 0) {
            that.$store.commit("set_loginToken", response.token);
            that.$store.commit("set_loginUserId", response.userid);
            that.$store.commit("set_isRegister", response.is_register);
            if (response.is_register == 1) {
              that.dialogShow = true;
            } else {
              that.$router.replace({
                name: "Home",
              });
            }
          } else {
            Toast({
              message: response.msg,
              duration: 3000,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
